import { render } from "./PopularRooms.vue?vue&type=template&id=d3d349ca&ts=true"
import script from "./PopularRooms.vue?vue&type=script&lang=ts"
export * from "./PopularRooms.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__